import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SubmissionPage = () => {
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState("Precious Soul!");

  useEffect(() => {
    const name = localStorage.getItem("student_name");
    if (name && name.trim()) {
      const firstName = name.trim().split(" ")[0];
      setStudentName(firstName || "Precious Soul!");
    }
  }, []);

  const handleAskAgain = () => {
    navigate("/QuestionPage");
  };

  return (
    <>
      <header className="hide_for_confirmation_page">
        <div className="homebanner">
          <img src="homebanner.png" alt="HomePage Banner" />
        </div>
        <div className="homelogo">
          <img src="church_logo_no_bg.png" alt="Church Logo" />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Cross Icon" />
        </div>
      </header>
      <header className="hide_for_media_query">
        <div className="media_query_banner media_query_banner1 ">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo media_query_logo1"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </header>

      <footer>
        <div className="homebody homebody_submit">
          <div className="sub-confirmation">
            <p>
              Thank You, <b>{studentName}!</b>
            </p>
            <p className="confirmation1a">
              We’ve received your question and we’re grateful you reached out.
            </p>
          </div>
          <div className="check">
            <img src="check.png" alt="Submission Check" />
          </div>
          <div className="submission">
            <p>
              Our team will prayerfully and thoughtfully respond to you via
              email. Please keep an eye on your inbox in the coming days.
            </p>
            <br />
            <p>
              Have more questions? Feel free to click the button again below —
              we're here to help.
            </p>
            <button
              className="homebody2 submissionbody"
              onClick={handleAskAgain}
            >
              <h5>Ask Another Question</h5>
            </button>
          </div>
        </div>
      </footer>
    </>
  );
};

export default SubmissionPage;
